module.exports = __webpack_public_path__ + "static/media/ship.233cebd9.svg";